module.exports = __webpack_public_path__ + "static/media/3DPPA16.32c25f88.jpg";